<template>
  <div class="man-hinh-dang-nhap">
    <div class="text-center mb-3">
      <img
        v-bind:alt="APP_TITLE"
        class="logo"
        src="../../assets/images/logo.png"
      />
    </div>
    <div class="color-blue-1 font-weight-bold text-center font-size-20">
      <span class="text-uppercase">
        {{ APP_TITLE }}
      </span>
    </div>
    <div class="login-box mt-4">
      <ValidationObserver ref="observer" tag="form">
        <b-form>
          <div v-if="!isRequireSetup2FA">
            <b-form-group class="required position-relative mb-0">
              <ValidationProvider
                :rules="`required_field:${TEN_DANG_NHAP}`"
                name="loginForm.ten_dang_nhap"
              >
                <div slot-scope="{ errors }">
                  <b-form-input
                    :class="{ 'is-danger': errors.length > 0 }"
                    @keyup.enter="dangNhap()"
                    id="ten_dang_nhap"
                    v-bind:placeholder="TEN_DANG_NHAP"
                    required
                    type="text"
                    v-model="loginForm.userName"
                  />
                  <p :class="{ error: errors.length > 0 }">{{ errors[0] }}</p>
                </div>
              </ValidationProvider>
              <div class="bieu-tuong-dang-nhap">
                <b-icon icon="person-fill" />
              </div>
            </b-form-group>
            <b-form-group class="required position-relative mb-0">
              <ValidationProvider
                :rules="`required_field:${MAT_KHAU}`"
                name="loginForm.mat_khau"
              >
                <div slot-scope="{ errors }">
                  <b-form-input
                    :class="{ 'is-danger': errors.length > 0 }"
                    @keyup.enter="dangNhap()"
                    id="mat_khau"
                    v-bind:placeholder="MAT_KHAU"
                    required
                    type="password"
                    v-model="loginForm.password"
                  />
                  <p :class="{ error: errors.length > 0 }">{{ errors[0] }}</p>
                </div>
              </ValidationProvider>
              <div class="bieu-tuong-dang-nhap">
                <b-icon icon="lock" />
              </div>
            </b-form-group>
          </div>
          <!-- MÀN MẪU redesign (mockup .dialog): đổi CẤU TRÚC trình bày vùng OTP - card + icon badge + ô to.
               GIỮ NGUYÊN mọi binding/directive: v-else, @click quayLai, loginForm.userName, v-otp-input attrs,
               :class otp-locked, otpInlineError, PushApprovalWaiting props/events. KHÔNG đụng <script>/cờ. -->
          <div class="auth-otp otp-scope text-center" v-else>
            <a href="#" class="otp-card__back d-inline-flex align-items-center" @click="quayLai">
              <span class="back d-inline-flex"><b-icon icon="arrow-left" /></span>
              <span>Quay lại</span>
            </a>
            <div class="otp-card">
              <div class="otp-card__badge" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 2 4 5v6c0 5 3.4 8.5 8 10 4.6-1.5 8-5 8-10V5z" />
                  <path d="m9 12 2 2 4-4" />
                </svg>
              </div>
              <div class="otp-card__title">Xác minh hai bước</div>
              <p class="otp-card__desc">
                Để giữ an toàn cho tài khoản của bạn, hệ thống muốn đảm bảo rằng
                bạn chính là người đang cố đăng nhập
              </p>
              <div class="otp-card__user">
                <span class="d-inline-flex">
                  <svg aria-hidden="true" fill="currentColor" focusable="false"
                    width="18px" height="18px" viewBox="0 0 24 24">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm6.36 14.83c-1.43-1.74-4.9-2.33-6.36-2.33s-4.93.59-6.36 2.33C4.62 15.49 4 13.82 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.82-.62 3.49-1.64 4.83zM12 6c-1.94 0-3.5 1.56-3.5 3.5S10.06 13 12 13s3.5-1.56 3.5-3.5S13.94 6 12 6z" />
                  </svg>
                </span>
                <span>{{ loginForm.userName }}</span>
              </div>

              <div
                style="flex-direction: row"
                class="otp-card__inputs d-flex justify-content-center"
                :class="{ 'otp-locked': otpLockoutSecondsRemaining !== null }"
              >
                <v-otp-input
                  ref="otpInput"
                  input-classes="otp-input"
                  separator="-"
                  :num-inputs="6"
                  :should-auto-focus="true"
                  :is-input-num="true"
                  @on-change="handleOnChange"
                  @on-complete="handleOnComplete"
                />
              </div>
              <!-- Inline error dưới ô OTP (Còn X lần thử / khoá tạm mm:ss). null = ẩn. -->
              <div
                v-if="otpInlineError"
                class="otp-error-inline text-center mb-2"
              >
                {{ otpInlineError }}
              </div>
              <PushApprovalWaiting
                v-if="loginAttemptId || pushShowLoginNowButton"
                :remaining-seconds="pushRemainingSeconds"
                :auto-complete-armed="pushAutoCompleteArmed"
                :auto-complete-remaining="pushAutoCompleteRemaining"
                :show-login-now-button="pushShowLoginNowButton"
                @confirm-now="handlePushAutoCompleteConfirm"
                @cancel-auto="handlePushAutoCompleteCancel"
                @login-now="handlePushLoginNow"
              />
            </div>
          </div>
        </b-form>
      </ValidationObserver>
      <ModalAuthenticator ref="authenticator" @authenticator="authenticator" />
      <QrEnrollModal ref="qrEnroll" @authenticator="authenticator" />
      <button v-if="isRequireSetup2FA"  :disabled="!isDisabledAuth"  @click="validateAuthenticator" class="btn dang-nhap-btn mt-4">Xác thực</button>
      <button v-else @click="dangNhap()" class="btn dang-nhap-btn mt-4">
        <span class="align-text-bottom">{{ BTN_DANGNHAP }}</span>
        <div class="lds-ring" v-show="laDangDangNhap">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </button>
    </div>
    <div class="copyright">{{ COPY_RIGHT }}</div>
    <BaseLoading :is-loading="loading" />
  </div>
</template>

<script>
import {
  getValueFromStorageByKey,
  LOCAL_STORAGE_KEY,
  removeValueToStorageByKey,
  setValueToStorageByKey
} from "@/utils/localStorage";
import * as message from "@/constants/message";
import { HTTP } from "@/api/http-common";
import { mapGetters } from "vuex";
import { COMMON_TEXT } from "@/constants/constants";
import { showMsgError } from "@/utils/commonUtils";
import forge from "node-forge";
import ModalAuthenticator from "./quan-tri-he-thong/ModalAuthenticator";
import QrEnrollModal from "./quan-tri-he-thong/QrEnrollModal";
import PushApprovalWaiting from "./PushApprovalWaiting";
import BaseLoading from "../common/BaseLoading";
// Push Autofill UX (Phase 08 - 2026-08-14) pure logic (twin qlvb-fe cb8336bcd, camelCase reader).
// KONGMING MUST-FIX #1 deadline-based timer + #2 failure path xử lý tại chỗ.
import {
  extractAutoCompleteDelaySeconds,
  extractAllowTotpFallback,
  armAutoComplete,
  AutoCompleteAction,
  AutoCompleteController,
  cancelAutoComplete,
  // F1 Deadline động (plan 260818-2208): siết hard-timeout theo remainingSeconds BE thay hardcode 600s.
  computePollDeadlineMs,
  POLL_FALLBACK_MS,
} from "@/utils/push-approval-login-common";

// Phase 07 (Push Approval login-web): polling mỗi 3s. Hard-timeout: F1 (plan 260818-2208) dùng deadline
// động theo remainingSeconds BE (nguồn sự thật TTL, tự khớp mọi env). POLL_TIMEOUT_MS giờ là FALLBACK MỀM
// khi chưa biết remaining (poll đầu chưa về / throw) - siết lại sau poll đầu qua computePollDeadlineMs.
const POLL_INTERVAL_MS = 3000;
const POLL_TIMEOUT_MS = POLL_FALLBACK_MS; // fallback mềm 600000, KHÔNG còn là trần cứng

export default {
  name: "DangNhap",
  components: {BaseLoading, ModalAuthenticator, QrEnrollModal, PushApprovalWaiting},
  data() {
    return {
      loading: false,
      isXacThuc: null,
      isDisabledAuth: false,
      maXacThuc: null,
      isRequireSetup2FA: false,
      // Countdown khoá tạm OTP (port từ qlvb-fe). otpInlineError: text dưới ô OTP ("Còn X lần thử" /
      // "Tài khoản tạm thời bị khoá. Sẽ mở lại sau mm:ss."). null = ẩn. otpLockoutSecondsRemaining: số
      // giây còn lại (null = không khoá). Chỉ khi countdown về 0 mới clear ô OTP + focus ô đầu.
      otpInlineError: null,
      otpLockoutSecondsRemaining: null,
      otpLockoutTimerId: null,
      loginForm: {
        userName: "",
        password: ""
      },
      // Phase 07: BÁM UC8 song song — có giá trị khi BE trả loginAttemptId (flag ON) ở stage-1.
      loginAttemptId: null,
      pollSecret: null,
      stage1Token: null,
      pushRemainingSeconds: 0, // Phase 02: đếm ngược TTL, cập nhật mỗi lần poll (BE = nguồn sự thật)
      pollingIntervalId: null,
      pollingTimeoutId: null,
      // F1 Deadline động (plan 260818-2208): siết hard-timeout theo remainingSeconds poll ĐẦU 1 lần
      // (cờ chống siết lại mỗi poll). Reset false ở stopPolling.
      pushDeadlineArmed: false,
      // Push Autofill UX (Phase 08 - 2026-08-14). Tách state FE state KHỎI flag payload BE (lesson case #3).
      pushAutoCompleteArmed: false,        // overlay countdown đang hiện
      pushAutoCompleteRemaining: 0,        // số giây tick UI (từ deadline tuyệt đối, robust throttle tab)
      pushAllowTotpFallback: true,         // default fail-open (Phase 3 backfill drift fix, common-fe direct)
      pushShowLoginNowButton: false,       // true CHỈ khi Huỷ + fallback=false (edge case user không kẹt)
      pushAutoCompleteController: null,    // AutoCompleteController instance (visibility listener + deadline)
      TEN_DANG_NHAP: COMMON_TEXT.FORM_LOGIN.TEN_DANG_NHAP,
      MAT_KHAU: COMMON_TEXT.FORM_LOGIN.MAT_KHAU,
      BTN_DANGNHAP: COMMON_TEXT.FORM_LOGIN.BTN_DANGNHAP,
      APP_TITLE: COMMON_TEXT.APP_TITLE,
      COPY_RIGHT: COMMON_TEXT.COPY_RIGHT,
      laDangDangNhap: false,
      publicKey: `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAqhSQUwu11FG5JK3xZsyv
y/gbEOch0SzVKVz+iKYg13LRi2Wwp0yub4husPcNwV96f1jOCTnTOgFvsKEpKtdw
1qRJ4O1KEDgaf23Z4eXY1XnrzGo2KlVYjvvsFYYWeUOLX1xHvULVyCcCcDPCWWC0
KFS9S8wDiTf4t08cM6BaBihvALfUgBEFe9hKbzrwuQlmnRzHzsk/eW0fcrJ4wiYx
DiDrSfIBEOfrlZ1GpT4HqKP4q8AxwqBWDR9c5nwmGTqDezt3ErreOVWaDFeSokeI
JjiNNdyG0CsbuPnR7vz4F1aZHKaX2gJib3buZ4U+IfoaLrCN98gPKBvo6I5IESda
iQIDAQAB
-----END PUBLIC KEY-----`,
    };
  },
  computed: {
    ...mapGetters({
      isLogin: "common/isLogin"
    })
  },
  // Phase 07: cleanup interval khi rời màn (route away / component unmount) — tránh leak.
  beforeDestroy() {
    this.stopPolling()
    // Cleanup countdown khoa tam OTP (khong leak setInterval khi roi man).
    this.stopOtpLockoutCountdown()
  },
  methods: {
    // Phase 02: chuẩn hoá remainingSeconds từ BE (số >0, floor); thiếu/không hợp lệ -> 0 (UI ẩn đếm ngược).
    extractRemaining(raw) {
      const n = Number(raw)
      return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0
    },
    async handleOnComplete(value) {
      this.maXacThuc = await value
      await this.validateAuthenticator()
    },
    handleOnChange(value) {
      if (value.length === 6) {
        this.isDisabledAuth = true
      } else {
        this.isDisabledAuth = false
      }
      // User go lai -> clear inline error (UX). NHUNG neu dang countdown khoa tam -> GIU text countdown
      // (khoa van hieu luc, go OTP moi cung khong verify duoc). Timer se tu clear khi ve 0.
      if (this.otpInlineError !== null && this.otpLockoutSecondsRemaining === null) {
        this.otpInlineError = null
      }
    },
    quayLai() {
      this.isRequireSetup2FA = !this.isRequireSetup2FA
      this.stopPolling()
      // Roi form OTP -> dung countdown khoa tam (khong hien man user/pass + khong leak timer).
      this.stopOtpLockoutCountdown()
    },
    // Phase 07: điểm dừng polling DUY NHẤT — gọi từ cả đường (a) UC8 (authenticator())
    // và đường (b) push (onPushApproved()) để không leak interval ở 2 nơi khác nhau.
    stopPolling() {
      if (this.pollingIntervalId) {
        clearInterval(this.pollingIntervalId)
        this.pollingIntervalId = null
      }
      if (this.pollingTimeoutId) {
        clearTimeout(this.pollingTimeoutId)
        this.pollingTimeoutId = null
      }
      // Push Autofill UX Phase 08: defense cleanup AutoCompleteController (visibility listener + interval).
      if (this.pushAutoCompleteController) {
        this.pushAutoCompleteController.stop()
      }
      // F1: reset cờ siết deadline -> attempt sau siết lại từ đầu theo remaining mới.
      this.pushDeadlineArmed = false
    },
    // F1/F4 (plan 260818-2208): xử lý hết hạn attempt DRY - dùng chung cho nhánh expired + timeout.
    // Ẩn phần push (ô OTP UC8 vẫn còn), reset countdown, toast rõ ràng cho user biết yêu cầu hết hạn
    // (thay vì ẩn im lặng như trước).
    expireHandler() {
      this.stopPolling()
      this.loginAttemptId = null
      this.pushRemainingSeconds = 0
      this.$toasted.global.showErrorMessage({
        message: 'Yêu cầu duyệt đã hết hạn, vui lòng nhập mã OTP',
      })
    },
    // Phase 07 (RT-2): start polling kèm pollSecret + Bearer stage1Token. F1: hard-timeout siết động theo
    // remainingSeconds BE (fallback mềm 600s tới khi có remaining). Hết hạn -> ẩn phần push, ô OTP (UC8) còn.
    startPolling() {
      this.stopPolling()
      this.pollingIntervalId = setInterval(() => {
        this.$store
          .dispatch('common/pollLoginApproval', {
            loginAttemptId: this.loginAttemptId,
            pollSecret: this.pollSecret,
            stage1Token: this.stage1Token,
          })
          .then((res) => {
            if (res.succeeded && res.data && res.data.status === 'approved') {
              // Push Autofill UX Phase 08: đọc allowTotpFallback + delay TRƯỚC khi decide complete.
              this.pushAllowTotpFallback = extractAllowTotpFallback(res)
              const armDecision = armAutoComplete(res)
              this.stopPolling() // polling vs armed conflict resolution: chọn (a) dừng polling khi armed
              if (armDecision.action === AutoCompleteAction.COMPLETE_IMMEDIATE) {
                this.onPushApproved('auto') // delay=0 = auto NGAY (backward compat 100%)
              } else {
                this.armAutoCompleteCountdown(armDecision.deadline, armDecision.delaySeconds)
              }
            } else if (res.succeeded && res.data && res.data.status === 'expired') {
              // F1/F4: attempt hết TTL -> ẩn phần push + toast (ô OTP UC8 vẫn còn). DRY qua expireHandler.
              this.expireHandler()
            } else if (res.succeeded && res.data) {
              // Phase 02: pending -> cập nhật đếm ngược từ remainingSeconds BE (nguồn sự thật).
              this.pushRemainingSeconds = this.extractRemaining(res.data.remainingSeconds)
              // F1 Deadline động (plan 260818-2208): sau poll ĐẦU có remaining>0 -> siết hard-timeout theo TTL
              // BE thật (1 lần, cờ pushDeadlineArmed). remaining<=0/không hợp lệ -> giữ fallback 600s (không
              // đá tức thì legacy). clearTimeout cũ trước khi set mới -> không double-fire.
              if (!this.pushDeadlineArmed && this.pushRemainingSeconds > 0) {
                if (this.pollingTimeoutId) {
                  clearTimeout(this.pollingTimeoutId)
                }
                this.pollingTimeoutId = setTimeout(
                  () => this.expireHandler(),
                  computePollDeadlineMs(this.pushRemainingSeconds)
                )
                this.pushDeadlineArmed = true
              }
              // Phase 08: đọc allowTotpFallback mỗi poll để state luôn cập nhật khi Huỷ.
              this.pushAllowTotpFallback = extractAllowTotpFallback(res)
            }
            // rejected -> tiếp tục chờ (BE có thể cho thử app khác); user luôn gõ OTP tay được (UC8).
          })
          .catch(() => {
            // Lỗi mạng/tạm thời khi poll: không phá luồng OTP tay (UC8), thử lại ở tick sau.
          })
      }, POLL_INTERVAL_MS)
      // F1: fallback MỀM ban đầu (chưa biết remaining). Siết lại theo remaining ở poll đầu (nhánh pending).
      // Dùng expireHandler DRY (ẩn push + toast) thay ẩn im lặng cũ.
      this.pushDeadlineArmed = false // attempt mới -> chưa siết
      this.pollingTimeoutId = setTimeout(() => this.expireHandler(), POLL_TIMEOUT_MS)
    },
    // Phase 07 (RT-1): poll thấy approved -> complete-login {loginAttemptId, pollSecret} + Bearer
    // stage1Token -> nhận token 24h đầy đủ -> tái dùng authenticator() để lưu token + vào QTHT.
    // Phase 08 (2026-08-14): nhận param `mode` = "auto"/"manual" (KONGMING FIND #2 forward CompletionMode
    // xuống common-be audit "push-complete:auto" vs ":manual"). Default "manual" backward compat.
    // KONGMING MUST-FIX #2 failure path: fail -> dismiss overlay + rơi về OTP tay + toast rõ ràng.
    onPushApproved(mode = 'manual') {
      this.stopPolling()
      this.$store
        .dispatch('common/completeLogin', {
          loginAttemptId: this.loginAttemptId,
          pollSecret: this.pollSecret,
          stage1Token: this.stage1Token,
          completionMode: mode, // Phase 08: forward xuống proxy -> common-be audit reason suffix
        })
        .then((res) => {
          if (res.succeeded) {
            this.pushAutoCompleteArmed = false
            this.pushShowLoginNowButton = false
            this.authenticator(res)
          } else {
            // KONGMING MUST-FIX #2: dismiss overlay + rơi về OTP tay + toast.
            this.pushAutoCompleteArmed = false
            this.pushShowLoginNowButton = false
            this.loginAttemptId = null
            this.$toasted.global.showErrorMessage({
              message: res.message || 'Không thể tự đăng nhập, vui lòng nhập mã OTP'
            });
          }
        })
        .catch((error) => {
          // KONGMING MUST-FIX #2: exception path (Redis hiccup / TTL race approve sát mép).
          this.pushAutoCompleteArmed = false
          this.pushShowLoginNowButton = false
          this.loginAttemptId = null
          this.$toasted.global.showErrorMessage({
            message: (error && error.data && error.data.message) || 'Không thể tự đăng nhập, vui lòng nhập mã OTP'
          });
        })
    },
    // Push Autofill UX Phase 08 (2026-08-14). KONGMING MUST-FIX #1 deadline-based: arm overlay countdown +
    // AutoCompleteController tự tick + fire complete("auto") khi deadline. User bấm OK trong countdown -> manual.
    armAutoCompleteCountdown(deadline, delaySeconds) {
      this.pushAutoCompleteArmed = true
      this.pushAutoCompleteRemaining = delaySeconds // hiển thị số giây ngay tức thì
      this.pushAutoCompleteController = new AutoCompleteController({
        onTick: (remaining) => {
          this.pushAutoCompleteRemaining = remaining
        },
        onComplete: (mode) => {
          // mode = "auto" (deadline qua) hoặc "manual" (user bấm OK trước)
          this.pushAutoCompleteArmed = false
          this.onPushApproved(mode)
        },
      })
      this.pushAutoCompleteController.arm(deadline)
    },
    // User bấm OK (Enter) trong countdown -> complete NGAY với mode="manual" (audit push-complete:manual).
    // Guard chống Enter conflict form login submit: userConfirmComplete pure module NOOP nếu chưa armed.
    handlePushAutoCompleteConfirm() {
      if (this.pushAutoCompleteController) {
        this.pushAutoCompleteController.confirmManual()
      }
    },
    // User bấm Huỷ (Esc) -> dừng armed KHÔNG gọi complete. Nếu allowTotpFallback=false -> hiện nút
    // "Đăng nhập ngay" để user không kẹt (attempt approved còn TTL Redis 600s).
    handlePushAutoCompleteCancel() {
      if (this.pushAutoCompleteController) {
        this.pushAutoCompleteController.cancel()
      }
      const cancelDecision = cancelAutoComplete(this.pushAllowTotpFallback)
      this.pushAutoCompleteArmed = false
      this.pushAutoCompleteRemaining = 0
      this.pushShowLoginNowButton = cancelDecision.showLoginNowButton
      // Attempt approved còn Redis TTL - user đổi ý bấm "Đăng nhập ngay" thì complete.
      // Nếu allowTotpFallback=true (default) -> ẩn hết push, user quay về form OTP tay bình thường.
    },
    // Nút "Đăng nhập ngay" edge case (fallback=false): user đã bấm Huỷ nhưng muốn login -> complete manual.
    handlePushLoginNow() {
      this.pushShowLoginNowButton = false
      this.onPushApproved('manual')
    },
    authenticator(res) {
      this.stopPolling()
      this.loginAttemptId = null
      setValueToStorageByKey(
        LOCAL_STORAGE_KEY.ACCESS_TOKEN,
        res.data.accessToken
      );
      setValueToStorageByKey(
        LOCAL_STORAGE_KEY.REFRESH_TOKEN,
        res.data.refreshToken
      );
      setValueToStorageByKey(
        LOCAL_STORAGE_KEY.PERMISSIONS,
        res.data.listPermissions
      );
      let userInfo = res.data.userInformation;
      setValueToStorageByKey(LOCAL_STORAGE_KEY.USER_INFO, userInfo);
      this.$store.dispatch("common/setIsLogin", true);
      this.$store.dispatch("common/setUserInfo", userInfo);
      localStorage.setItem("isLogin", true);
      HTTP.defaults.headers = {
        Authorization: `Bearer ${getValueFromStorageByKey(
          LOCAL_STORAGE_KEY.ACCESS_TOKEN
        )}`,
        "Access-Control-Allow-Origin": "*"
      };
      //this.$store.dispatch("common/setPermission");
      if (res.data.expiresIn) {
        const minuteTimeout = res.data.AccessToken.ExpiresIn * 60 * 1000;
        setTimeout(() => {
          removeValueToStorageByKey(LOCAL_STORAGE_KEY.ACCESS_TOKEN);
          removeValueToStorageByKey(LOCAL_STORAGE_KEY.REFRESH_TOKEN);
          removeValueToStorageByKey(LOCAL_STORAGE_KEY.PERMISSIONS);
          removeValueToStorageByKey(LOCAL_STORAGE_KEY.USER_INFO);
          removeValueToStorageByKey(LOCAL_STORAGE_KEY.APP_ID);
        }, minuteTimeout);
      }
      this.$toasted.clear();
      this.$toasted.global.showSuccessMessage({
        message: message.DANG_NHAP_THANH_CONG
      });
      this.$router.push({
        //name: ROUTE_NAME.TRANG_CHU,
        path: `/`
      });
    },
    validateAuthenticator() {
      this.loading = true
      this.$store
          .dispatch('common/validateLogin', {
            twoFactorCode: this.maXacThuc,
          })
          .then((res) => {
            if (res.succeeded) {
              this.loading = false
              this.otpInlineError = null
              this.stopOtpLockoutCountdown()
              this.authenticator(res)
            } else {
              // Verify fail nhung BE tra 200 succeeded=false: xu ly nhu nhanh loi (con luot / khoa tam).
              // common-be ServiceResponse dung `message` so it (khac qlvb-be `Messages[]`) -> doc res.message.
              this.loading = false
              this.handleOtpVerifyFail(res, res.message)
            }
          })
          .catch((error) => {
            this.loading = false
            // Verify fail (BE tra 4xx: OTP sai / khoa tam). error = error.response; body o error.data.
            const body = (error && error.data) || {}
            this.handleOtpVerifyFail(body, body.message)
          })
    },
    // Xu ly verify fail: doc remainingAttempts + lockoutSecondsRemaining (BE tra khi rate-limit).
    // - remaining > 0 (con luot, CHUA khoa): GIU ma cu tren o + hien inline "Con X lan thu". KHONG clear.
    // - remaining === 0 (khoa tam): neu co lockoutSec -> countdown mm:ss; het khoa moi clear o (trong timer).
    // - khong co field (BE cu / loi khac): toast fallback nhu cu, GIU ma.
    // Doc CA 2 casing (camelCase common-be default + PascalCase phong khi doi) - phong thu casing over-the-wire.
    handleOtpVerifyFail(payload, fallbackMsg) {
      const p = payload || {}
      const remaining =
        p.remainingAttempts != null ? p.remainingAttempts
        : p.RemainingAttempts != null ? p.RemainingAttempts
        : null
      const lockoutSec =
        p.lockoutSecondsRemaining != null ? p.lockoutSecondsRemaining
        : p.LockoutSecondsRemaining != null ? p.LockoutSecondsRemaining
        : null
      if (typeof remaining === 'number' && remaining >= 0) {
        if (remaining === 0) {
          // Khoa tam: hien CA inline + toast (text inline nho de bo sot khi dang dan ma).
          if (typeof lockoutSec === 'number' && Number.isFinite(lockoutSec) && lockoutSec > 0) {
            this.startOtpLockoutCountdown(lockoutSec)
          } else {
            this.otpInlineError = 'Tài khoản tạm thời bị khoá. Vui lòng thử lại sau.'
          }
          this.$toasted.global.showErrorMessage({
            message: 'Tài khoản tạm thời bị khoá do nhập sai OTP nhiều lần.'
          });
        } else {
          // Con luot: GIU ma cu, chi hien inline "Con X lan thu" (user thay ma vua go de sua).
          this.otpInlineError = `Sai mã xác thực. Còn ${remaining} lần thử.`
        }
      } else {
        // BE cu / field absent: toast fallback, GIU ma cu tren o.
        this.otpInlineError = null
        this.$toasted.global.showErrorMessage({
          message: fallbackMsg || 'Có lỗi xảy ra'
        });
      }
    },
    // Xoa toan bo o OTP + dua con tro ve o dau. clearInput() cua @bachdgvn/vue-otp-input:
    // reset otp=[] (o trong) + activeInput=0 -> child SingleOtpInput watch prop focus (false->true)
    // tu goi $refs.input.focus()+select(). Guard ref ton tai (chi mounted khi dang o man OTP).
    // CHI goi khi HET HAN KHOA (trong startOtpLockoutCountdown khi ve 0) - KHONG goi moi lan verify fail.
    resetOtpInputs() {
      this.maXacThuc = null
      if (this.$refs.otpInput && typeof this.$refs.otpInput.clearInput === 'function') {
        this.$refs.otpInput.clearInput()
      }
    },
    // Bat dau tick countdown "khoa tam mo lai sau mm:ss". BE tra so giay con lai (source of truth);
    // FE tu tick xuong 1s/lan. Khi ve 0 -> clear o OTP + focus o dau + doi text "Ban co the thu lai".
    startOtpLockoutCountdown(seconds) {
      this.stopOtpLockoutCountdown()
      this.otpLockoutSecondsRemaining = Math.max(0, Math.floor(seconds))
      this.otpInlineError = this.buildLockoutText(this.otpLockoutSecondsRemaining)
      // Readonly khi dang khoa: bo focus o dang active -> chan ban phim (CSS pointer-events:none tren
      // wrapper .otp-locked da chan click focus lai). Guard SSR/test khong co document.
      if (typeof document !== 'undefined' && document.activeElement && document.activeElement.blur) {
        document.activeElement.blur()
      }
      this.otpLockoutTimerId = setInterval(() => {
        if (this.otpLockoutSecondsRemaining <= 1) {
          this.stopOtpLockoutCountdown()
          // HET HAN KHOA: xoa ma OTP cu + focus o dau (DIEM DUY NHAT clear o).
          this.resetOtpInputs()
          this.otpInlineError = 'Đã hết thời gian khoá. Bạn có thể thử lại.'
          return
        }
        this.otpLockoutSecondsRemaining -= 1
        this.otpInlineError = this.buildLockoutText(this.otpLockoutSecondsRemaining)
      }, 1000)
    },
    stopOtpLockoutCountdown() {
      if (this.otpLockoutTimerId) {
        clearInterval(this.otpLockoutTimerId)
        this.otpLockoutTimerId = null
      }
      this.otpLockoutSecondsRemaining = null
    },
    buildLockoutText(sec) {
      const mm = Math.floor(sec / 60)
      const ss = sec % 60
      const pad = (n) => (n < 10 ? '0' + n : '' + n)
      return `Tài khoản tạm thời bị khoá. Sẽ mở lại sau ${pad(mm)}:${pad(ss)}.`
    },
    async dangNhap() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return;
      }
      var rsa = forge.pki.publicKeyFromPem(this.publicKey);
      var encryptedPassword = window.btoa(rsa.encrypt(this.loginForm.password));
      const payload = {
        userName: this.loginForm.userName,
        password: encryptedPassword,
        environment: "Stagging"
      };
      this.$store
        .dispatch("common/login", payload)
        .then(res => {
          if (res.data.succeeded) {
            setValueToStorageByKey(
              LOCAL_STORAGE_KEY.ACCESS_TOKEN,
              res.data.data.accessToken
            );
            HTTP.defaults.headers = {
              Authorization: `Bearer ${getValueFromStorageByKey(
                LOCAL_STORAGE_KEY.ACCESS_TOKEN
              )}`,
              "Access-Control-Allow-Origin": "*"
            };
            // QR-handoff cho CẢ 2 luồng enroll bằng app QLVB (token stage-1 đã set header Bearer ở trên):
            // - needEnrollDevice: user đã bật 2FA nhưng chưa có thiết bị.
            // - isRequireSetup2FA: setup 2FA LẦN ĐẦU (thay QR otpauth cũ - app QLVB không quét được JSON {t,u}).
            // ConfirmEnrollBinding (BE) tự bật IsUsingSecretKey2FA khi user chưa bật -> hoàn tất setup lần đầu.
            if (res.data.data.needEnrollDevice || res.data.data.isRequireSetup2FA) {
              this.isXacThuc = false
              this.isRequireSetup2FA = false // KHÔNG hiện form otpauth cũ; QrEnrollModal tự lo luồng
              this.$refs.qrEnroll.showModal()
              return
            }
            // User ĐÃ bật 2FA (isUsing2FA, KHÔNG setup/enroll) -> chuyển sang màn nhập OTP.
            // Biến local isRequireSetup2FA đóng vai cờ CHUYỂN-MÀN-OTP (template: !isRequireSetup2FA = form
            // login; else = ô OTP). Set true để hiện ô OTP cho user đã bật 2FA (khôi phục hành vi cũ, tránh
            // regression: fix QR-handoff trước bỏ dòng này -> user đã bật 2FA kẹt màn login).
            if (res.data.data.isUsing2FA) {
              this.isRequireSetup2FA = true
              this.isXacThuc = false
            }
            // OFF 2FA per-user (Approach A - 2026-08-11): user exempt (BE trả full token ngay stage-1)
            // HOẶC (hiếm) legacy user không dùng 2FA -> 3 cờ trên đều false -> login hoàn tất NGAY,
            // KHÔNG qua enroll/setup/nhập OTP. THIẾU nhánh này = exempt user kẹt màn login im lặng
            // (BE trả 200 nhưng FE không lưu token/route -> đứng yên ở form login).
            // Reuse authenticator() (nhánh success của validateAuthenticator/onPushApproved) để lưu
            // userInfo/permissions + push route '/'. authenticator(param) đọc param.data.xxx nên
            // truyền res.data (body {succeeded, data:{...}}) - khớp shape với validateLogin resolve.
            if (
              !res.data.data.needEnrollDevice &&
              !res.data.data.isRequireSetup2FA &&
              !res.data.data.isUsing2FA
            ) {
              this.authenticator(res.data)
              return
            }
            if (this.maXacThuc) {
              this.isXacThuc = true
            }
            // Phase 07: BÁM UC8 song song — hiện phần "chờ duyệt qua app" + polling khi BE trả
            // loginAttemptId (flag ON), CHO CẢ user setup-2FA-lần-đầu LẪN user đã-có-2FA đăng nhập
            // (đặt NGOÀI nhánh isRequireSetup2FA để không lệ thuộc trạng thái setup). Flag OFF ->
            // loginAttemptId null -> RG1 (chỉ ô OTP nguyên như cũ, KHÔNG polling).
            if (res.data.data.loginAttemptId) {
              this.loginAttemptId = res.data.data.loginAttemptId
              this.pollSecret = res.data.data.pollSecret
              this.stage1Token = res.data.data.accessToken
              this.startPolling()
            } else {
              this.loginAttemptId = null
              this.pollSecret = null
              this.stage1Token = null
            }
            // setValueToStorageByKey(
            //   LOCAL_STORAGE_KEY.ACCESS_TOKEN,
            //   res.data.data.accessToken
            // );
            // setValueToStorageByKey(
            //   LOCAL_STORAGE_KEY.REFRESH_TOKEN,
            //   res.data.data.refreshToken
            // );
            // setValueToStorageByKey(
            //   LOCAL_STORAGE_KEY.PERMISSIONS,
            //   res.data.data.listPermissions
            // );
            // let userInfo = res.data.data.userInformation;
            // setValueToStorageByKey(LOCAL_STORAGE_KEY.USER_INFO, userInfo);
            // this.$store.dispatch("common/setIsLogin", true);
            // this.$store.dispatch("common/setUserInfo", userInfo);
            // localStorage.setItem("isLogin", true);
            // HTTP.defaults.headers = {
            //   Authorization: `Bearer ${getValueFromStorageByKey(
            //     LOCAL_STORAGE_KEY.ACCESS_TOKEN
            //   )}`,
            //   "Access-Control-Allow-Origin": "*"
            // };
            // //this.$store.dispatch("common/setPermission");
            // if (res.data.expiresIn) {
            //   const minuteTimeout = res.data.AccessToken.ExpiresIn * 60 * 1000;
            //   setTimeout(() => {
            //     removeValueToStorageByKey(LOCAL_STORAGE_KEY.ACCESS_TOKEN);
            //     removeValueToStorageByKey(LOCAL_STORAGE_KEY.REFRESH_TOKEN);
            //     removeValueToStorageByKey(LOCAL_STORAGE_KEY.PERMISSIONS);
            //     removeValueToStorageByKey(LOCAL_STORAGE_KEY.USER_INFO);
            //     removeValueToStorageByKey(LOCAL_STORAGE_KEY.APP_ID);
            //   }, minuteTimeout);
            // }
            // this.$toasted.clear();
            // this.$toasted.global.showSuccessMessage({
            //   message: message.DANG_NHAP_THANH_CONG
            // });
            // this.$router.push({
            //   //name: ROUTE_NAME.TRANG_CHU,
            //   path: `/`
            // });
          } else {
            this.$toasted.clear();
            this.$toasted.global.showErrorMessage({
              message: res.data.message
            });
          }
        })
        .catch(error => {
          showMsgError("Tên đăng nhập hoặc mật khẩu không đúng");
        });
    }
  }
};
</script>
<style lang="scss">
  // .otp-input da di doi sang assets/css/components/_otp.scss (single owner, RT-7).
  // KHONG dinh nghia lai o day de tranh trung/specificity war.
  // MÀN MẪU redesign (mockup .dialog). Đổi cấu trúc trình bày vùng OTP thành card + badge + ô to.
  // KHÔNG đụng <script>/cờ/binding. 1 nút flipping (isRequireSetup2FA) + isDisabledAuth (!) NGƯỢC qlvb +
  // loginAttemptId discriminator + dòng side-effect :276 GIỮ NGUYÊN.
  .auth-otp {
    font-family: var(--otp-sans);
    color: var(--otp-ink);

    // Link "Quay lại" - đưa lên trên card, canh trái.
    .otp-card__back {
      color: var(--otp-blue);
      font-size: 13.5px;
      font-weight: 500;
      text-decoration: none;
      margin-bottom: 14px;
      gap: 5px;
      &:hover { color: var(--otp-blue-600); }
    }

    // KHÔNG bọc khung card riêng: màn login đã có 1 khung bao ngoài sẵn (layout login gốc).
    // Thêm border/shadow ở đây -> 2 khung lồng nhau (box-in-box) rối. Wrapper trong suốt, chỉ canh giữa.
    .otp-card {
      max-width: 320px;
      margin: 0 auto;
      text-align: center;
    }

    // Icon badge tròn (khiên bảo mật) - nền blue nhạt, icon xanh.
    .otp-card__badge {
      width: 52px;
      height: 52px;
      border-radius: 14px;
      background: var(--otp-blue-050);
      display: grid;
      place-items: center;
      margin: 0 auto 16px;
      svg { width: 26px; height: 26px; stroke: var(--otp-blue); }
    }

    .otp-card__title {
      font-family: var(--otp-display);
      font-weight: 600;
      font-size: 19px;
      color: var(--otp-ink);
      margin-bottom: 8px;
    }
    .otp-card__desc {
      font-size: 13px;
      color: var(--otp-muted);
      line-height: 1.55;
      max-width: 300px;
      margin: 0 auto 18px;
    }

    // Chip user - pill nền surface-2.
    .otp-card__user {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      border: 1px solid var(--otp-border);
      background: var(--otp-surface-2);
      color: var(--otp-ink-soft);
      padding: 5px 12px;
      border-radius: 20px;
      font-size: 12.5px;
      font-weight: 500;
      margin-bottom: 22px;
      svg { color: var(--otp-muted); }
    }

    // Cụm ô OTP - khoảng cách rộng hơn.
    .otp-card__inputs {
      margin-bottom: 16px;
      gap: 2px;
    }

    .otp-error-inline {
      color: var(--otp-danger);
      font-size: 13px;
      margin-bottom: 12px;
    }
  }

  // Ô OTP TO ĐẸP - CHỈ trong card login (override kích thước global .otp-input 35px, không đụng global).
  // Nhắm DOM widget bên thứ 3 nên phải non-scoped -> đặt trong block <style> non-scoped hiện tại.
  .auth-otp .otp-card__inputs .otp-input {
    width: 48px !important;
    height: 56px !important;
    margin: 0 5px !important;
    font-size: 22px !important;
    font-weight: 600;
    border-radius: var(--otp-radius-sm) !important;
  }
  // Readonly khi dang khoa tam OTP: chan click focus vao o + lam mo bao hieu disabled.
  // Ket hop blur() trong startOtpLockoutCountdown de chan ban phim (pointer-events chi chan chuot).
  .otp-locked {
    pointer-events: none;
    opacity: 0.6;
  }
</style>
